import DOMPurify from 'dompurify'

const SANITIZE_PROFILES = {
  simpleText: {
    ALLOWED_TAGS: ['br', 'b', 'strong', 'i', 'em', 'span', 'p', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['class'],
    FORBID_ATTR: ['style'],
    ALLOW_DATA_ATTR: false,
  },
  richText: {
    ALLOWED_TAGS: ['a', 'div', 'p', 'br', 'b', 'strong', 'i', 'em', 'span', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'class'],
    FORBID_ATTR: ['style'],
    ALLOW_DATA_ATTR: false,
  },
}

function normalizeHtml(html) {
  if (html === null || html === undefined) {
    return ''
  }
  return typeof html === 'string' ? html : String(html)
}

export function sanitizeHtml(html, profile = 'richText') {
  const normalizedHtml = normalizeHtml(html)
  const sanitizeProfile = SANITIZE_PROFILES[profile] || SANITIZE_PROFILES.richText
  return DOMPurify.sanitize(normalizedHtml, sanitizeProfile)
}

export { SANITIZE_PROFILES }
